import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Confidentiality from "./Confidentiality";
import ConfidentialityKanba from "./ConfidentialityKanba";
import Layout from "./Layout";
import OurTodos from "./OurTodos";
import ConfidentialityOurTodos from "./ConfidentialityOurTodos";
import Kanba from "./Kanba";
import ConfidentialitySmartBoard from "./ConfidentialitySmartBoard";
import SmartBoard from "./SmartBoard";
import ConfidentialityDoToday from "./ConfidentialityDoToday";
import Expenseo from "./Expenseo";
import ConfidentialityExpenseo from "./ConfidentialityExpenseo";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<App />} />
          <Route path="confidentiality" element={<Confidentiality />} />
          <Route path="ourtodos" element={<OurTodos />} />
          <Route path="kanba" element={<Kanba />} />
          <Route path="smartboard" element={<SmartBoard />} />
          <Route path="budget" element={<Expenseo />} />
          <Route
            path="confidentiality-dotoday"
            element={<ConfidentialityDoToday />}
          />
          <Route
            path="confidentiality-kanba"
            element={<ConfidentialityKanba />}
          />
          <Route
            path="confidentiality-ourtodos"
            element={<ConfidentialityOurTodos />}
          />
          <Route
            path="confidentiality-smartboard"
            element={<ConfidentialitySmartBoard />}
          />
          <Route
            path="confidentiality-budget"
            element={<ConfidentialityExpenseo />}
          />
          <Route path="*" element={<App />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
